import { Avatar, styled, MenuItem } from '@mui/material'
import { Link } from 'react-router-dom' // Use the standard Link from react-router-dom

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  width: '198px',
  padding: '9px 15px',
  '&:last-child': {
    borderBottom: 'none'
  }
}))

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  display: 'flex',
  padding: '9px 15px',
  width: '100%',
  height: '100%'
}))

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  color: theme.palette.text.primary
}))
